import { useEffect } from 'react';
import { Link } from '@tanstack/react-router';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import { useFiling, useFilingActions } from './state';
import { FilingShell } from './components/FilingShell';

export function FilingsPage() {
  const snapshot = useFiling((s) => s);
  const actions = useFilingActions();
  useEffect(() => {
    if (snapshot.matches('idle')) actions.loadFilings();
  }, [snapshot.value]);
  const filings = snapshot.context.filings;
  return (
    <FilingShell title="Firm filings">
      {snapshot.matches('loading') && (
        <p className="border border-border bg-card p-5 text-sm text-muted-foreground">Loading filing register…</p>
      )}
      {snapshot.matches('error') && (
        <div className="border border-destructive/40 bg-card p-5 text-sm">
          <p>We couldn’t load the filing register.</p>
          <Button className="mt-4" variant="outline" onClick={actions.loadFilings}>
            Try again
          </Button>
        </div>
      )}
      {snapshot.matches('ready') && filings.length === 0 && (
        <div className="border border-dashed border-border bg-card p-8">
          <p className="font-medium">No filings yet</p>
          <p className="mt-1 text-sm text-muted-foreground">Opened fiduciary returns will appear here.</p>
        </div>
      )}
      {snapshot.matches('ready') && filings.length > 0 && (
        <div className="overflow-hidden border border-border bg-card">
          <div className="grid grid-cols-[1fr_9rem_7rem] border-b border-border px-4 py-3 text-xs font-medium uppercase tracking-[0.12em] text-muted-foreground">
            <span>Filing record</span>
            <span>Status</span>
            <span />
          </div>
          {filings.map((filing) => (
            <div
              key={filing.filingId}
              className="grid grid-cols-[1fr_9rem_7rem] items-center border-b border-border px-4 py-4 last:border-0"
            >
              <span className="font-medium">{filing.filingId}</span>
              <Badge variant="outline" className="w-fit">
                {filing.status ?? 'Pending'}
              </Badge>
              <Link
                to="/filings/$filingId"
                params={{ filingId: filing.filingId }}
                className="text-right text-sm text-primary underline-offset-4 hover:underline"
              >
                Review
              </Link>
            </div>
          ))}
        </div>
      )}
      <div className="mt-8 border border-border bg-muted/30 p-5">
        <p className="text-sm font-medium">Hand in a statement</p>
        <p className="mt-1 text-sm text-muted-foreground">
          Statement hand-in is completed from the statement workspace.
        </p>
        <Button data-jr-key="hand-in-statement" variant="outline" className="mt-4" disabled>
          Open statement workspace
        </Button>
        <span data-jr-key="hand-in-statement-id" className="sr-only" />
      </div>
    </FilingShell>
  );
}
